import { render } from "./InstgramStoryReview.vue?vue&type=template&id=67a77675&scoped=true"
import script from "./InstgramStoryReview.vue?vue&type=script&lang=js"
export * from "./InstgramStoryReview.vue?vue&type=script&lang=js"

import "./InstgramStoryReview.vue?vue&type=style&index=0&id=67a77675&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a77675"]])

export default __exports__